import cn from 'classnames'
import { PlausibleEvent } from 'enums/plausible'
import { useField } from 'formik'
import React, { useCallback, useState } from 'react'
import usePlausible from 'utils/hooks/usePlausible'
import FieldError from '../FieldError/FieldError'

import { useTranslation } from 'next-i18next'
import Link from 'next/link'

import { MiniRecoveryIcon } from 'components/Images/Icons'

import styles from './Password.module.scss'
import useIsQVariant from 'utils/hooks/useIsQVariant'

interface PasswordProps extends React.InputHTMLAttributes<HTMLInputElement> {
  referrer: string
  name: string
  icon?: any
}

const Password = ({ referrer, name, icon, ...props }: PasswordProps) => {
  const [field] = useField(name)
  const [t] = useTranslation(['main'])
  const [visible, setVisible] = useState<boolean>(false)
  const setEvent = usePlausible()

  const isQ = useIsQVariant()

  const onClick = useCallback(() => {
    setEvent(PlausibleEvent.ClickedSignInForgot, {
      step: 2,
      referrer,
    })
  }, [setEvent])

  return (
    <div className={styles.wrapper}>
      <span className={cn(styles.passwordInput, { [styles.visible]: visible })}>
        <input type={visible ? 'text' : 'password'} {...field} {...props} />
        <span onClick={() => setVisible(!visible)} className={styles.showPasswordButton} />
      </span>
      <span className={styles.additional}>
        {icon ? (
          <Link href={isQ ? '/q/auth/recovery' : '/auth/recovery'} id="login-form-password-link">
            <div className={styles.link} onClick={() => onClick()}>
              {t('main:authForgotPassword')}
              <MiniRecoveryIcon />
            </div>
          </Link>
        ) : (
          <div />
        )}
        <FieldError name={name} />
      </span>
    </div>
  )
}

export default Password
